export function PartsAuthorityInvoiceService (
  $q,
  sessionObjAPI,
) {
  var PartsAuthorityInvoice = function (customer, vehicle) {
    this.origin   = sessionObjAPI.base().origin;
    this.vehicle  = vehicle || {};
    this.customer = customer ||  {};
  };

  PartsAuthorityInvoice.prototype.buildQuery = function (url, invoice) {
    const self = this;

    let queryString = {
      hookUrl: url,
      invoice_id: invoice.id,
      logonId: sessionObjAPI.company().parts_authority_settings.parts_authority_username,
      logonPassword: sessionObjAPI.company().parts_authority_settings.parts_authority_password,
      source: 'WORKSHOP'
    };

    if (self.vehicle.id) {
      if (self.vehicle.vin) {
        queryString.vin = self.vehicle.vin;
      }

      else if (self.vehicle.build_date && self.vehicle.make && self.vehicle.model) {
        if (self.vehicle.build_date) {
          queryString.vyear = self.vehicle.build_date.length > 4 ? self.vehicle.build_date.substr(3, 7) : self.vehicle.build_date;
        }

        queryString.vmake = self.vehicle.make;
        queryString.vmodel = self.vehicle.model;
      }    
    }

    return $.param(queryString);
  };

  PartsAuthorityInvoice.prototype.buildUrl = function (invoice) {
    const self = this;

    if (self.vehicle) {
      return self.vehicle.id ?
        `${self.origin}workshop.html#/${self.customer.id}/${self.vehicle.id}/invoice/${invoice.id}` :
        `${self.origin}workshop.html#/${self.customer.id}/invoice/${invoice.id}`;
    }
    
    return `${self.origin}workshop.html#/${self.customer.id}/invoice/${invoice.id}`;
  };

  PartsAuthorityInvoice.prototype.getPortalUrl = function(invoice) {
    const self = this;

    let url         = self.buildUrl(invoice);
    let queryString = self.buildQuery(url, invoice);

    return $q.when(`/parts-authority.html?${queryString}`);
  };

  return PartsAuthorityInvoice;
}
